/**
 * List of application roles available to users in QUILT
 */
export enum UserRole {
    User = 'QUILTUser',
    Admin = 'GlobalAdmin',
    Reader = 'QUILTReader',
    DocusignIntegration = 'DocusignIntegration',
    EventGrid = 'EventGrid',
    Treasury = 'QUILTTreasury'
}
  